import React from "react";
import { Card, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./SingleCourse.css";

const SingleCourse = (props) => {
  const navigate = useNavigate();
  const { title, img, description, number, id } = props.data;
  const detailsView = (id) => {
    navigate("/courses/" + id);
    

  };
  return (
    <>
      <Col md="6" sm="12" lg="4" className="pb-5">
        <Card className="rounded">
          <Card.Body>
            <img className="single-course-img" src={img} alt="" />
            <Card.Title className="single-course-card-title">
              {title}
            </Card.Title>

            <Card.Text>
              {description.length > 50
                ? description.slice(0, 100) + " ...."
                : description}
            </Card.Text>
            <div className="d-flex justify-content-between align-items-center ">
              <span
                className="SingleCourse-price fw-bold my-4"
                style={{ color: "var(--accent-color)" }}
              >
                Price: ${number}
              </span>
              <button
                onClick={() => detailsView(id)}
                className="btn-style-1 single-course-btn "
              >
                Get Enrol
              </button>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

export default SingleCourse;
